import { useParams, useNavigate } from "react-router-dom";
import { useState, useCallback, useEffect } from "react";
// import { ReactComponent as PlayIcon } from '../assets/logos/play button.svg';
import { ReactComponent as OpenIcon } from '../assets/logos/open project.svg';
import { ReactComponent as OptionIcon } from '../assets/logos/options.svg';
import { ReactComponent as EditIcon } from '../assets/logos/edit name.svg';
import {
  getIdeProjects,
  renameProject,
  deleteProject,
  addOrRemoveIdeProjectPortfolio,
  submitIdeProjectForEvaluation,
  cancelIdeProjectSubmission,
} from "../services/ide-apis";
import { Link } from "react-router-dom";
import { global_var } from "../services/cs-lab-config";
import {
  message,
  Card,
  List,
  Avatar,
  Dropdown,
  Typography,
  Modal,
  Input,
  Divider,
  Badge,
  Row,
  Col,
  Button,
  Empty,
  Tooltip,
} from "antd";
import {
  CloseOutlined,
  DownloadOutlined,
  StarOutlined,
  StarFilled,
  ReadOutlined,
  ReadFilled,
  LeftOutlined,
} from "@ant-design/icons";
import {
  formatDate,
  getIdeProjectLogo,
  getEvaluationStatusColor,
  getEvaluationStatusName,
  getIdeProjectTypeMetaData,
  trackEvent,
} from "./utils/util-functions";
import CardSkeleton from "./utils/card-skeleton";
import ProjectFilters from "./utils/project-filters";
import {handleDownloadProject} from "./ide/download-ide-project"
import  noDataImage  from '../assets/images/No notifcations.png'

const { Meta } = Card;

const Projects = () => {
  const navigate = useNavigate();
  const { projectStack } = useParams();

  document.title = "CS Lab | " + projectStack + " Projects";

  const [projects, setProjects] = useState([]);
  const [projectLoading, setProjectLoading] = useState(false);
  const [totalProjectsCount, setTotalProjectsCount] = useState(0);
  const [showCreateProjectButton, setShowCreateProjectButtonButton] = useState(false);

  // const userToken = localStorage.getItem("token");
  const userToken = sessionStorage.getItem('token');
  const MAX_LENGTH = 40;

  useEffect(() => {
    const projectMetaData = getIdeProjectTypeMetaData(projectStack);
    if (projectMetaData.createProjectsInProjects) {
      setShowCreateProjectButtonButton(true);
    } else {
      setShowCreateProjectButtonButton(false);
    }
  }, [projectStack]);

  function setActions(projectObj) {
    const actions = [
      <Tooltip title={'Edit Project'}>
        <OpenIcon
          key="ide"
          onClick={() => navigateToIDE(projectObj)}
        />
      </Tooltip>
    ];
    if (projectObj.projectLanguage !== "sql2") {
      //
      const dropdownItems = [];
      if (global_var.role_id === global_var.STUDENT_ROLE_ID) {
        dropdownItems.push(
          {
            label: projectObj.showInPortFolio
              ? "Remove from portfolio"
              : "Add to portfolio",
            key: "1",
            icon: projectObj.showInPortFolio ? (
              <StarFilled />
            ) : (
              <StarOutlined />
            ),
            onClick: () => handleAddOrRemoveToPortfolio(projectObj),
          },
          {
            label: projectObj.submittedForEvaluation
              ? "Cancel Submission"
              : "Submit for evaluation",
            key: "2",
            icon: projectObj.submittedForEvaluation ? (
              <ReadFilled />
            ) : (
              <ReadOutlined />
            ),
            onClick: () => {
              if (projectObj.evaluationStatus === "Evaluated") {
                message.info("This project is evaluated by teacher.");
                return;
              }

              if (projectObj.submittedForEvaluation) {
                handleCancelProjectSubmission(projectObj);

                trackEvent("projects_cancel_submission_button_clicked", {
                  ide_project_stack_name: projectObj.projectLanguage,
                });
              } else {
                trackEvent("projects_submit_button_clicked", {
                  ide_project_stack_name: projectObj.projectLanguage,
                });

                handleProjectSubmission(projectObj);
              }
            },
          }
        );
      }
      if (projectObj.projectLanguage === "python" || projectObj.projectLanguage === "html_css") {
        dropdownItems.push({
          label: "Download project",
          key: "3",
          icon: <DownloadOutlined />,
          onClick: () => handleDownloadProject(projectObj),
        });
      }
      dropdownItems.push({
        label: "Delete project",
        key: "4",
        danger: true,
        icon: <CloseOutlined />,
        onClick: () => handleDeleteProject(projectObj),
      });
      actions.push(
        // <PlayIcon
        //   key="play"
        //   onClick={() => alert("coming soon")}
        //   style={{
        //     color: "teal",
        //   }}
        // />,
        <Dropdown
          menu={{
            items: dropdownItems,
          }}
          trigger={["click"]}
        >
          <OptionIcon
            key="options"
          />
        </Dropdown>
      );
    }
    return actions;
  }

  function handleEditProject(projectObj) {
    let newProjectName = projectObj.name;
    Modal.confirm({
      title: "Edit project - " + projectObj.name,
      icon: null,
      content: (
        <Input
          defaultValue={projectObj.name}
          placeholder="Enter new project name"
          onChange={(e) => (newProjectName = e.target.value)}
        />
      ),
      onOk() {
        trackEvent("projects_edit_project_name_ok_clicked", {
          ide_project_stack_name: projectObj.projectLanguage,
        });

        if (newProjectName.trim() === "") {
          message.error("Please enter a valid project name");
          return;
        } if (newProjectName.length > MAX_LENGTH) {
          message.error(`The file name exceeds the maximum allowed limit. Use a shorter name`);
          return;
        }

        if (newProjectName === projectObj.name) {
          message.info("Please enter a new project name");
          return;
        }

        renameProject(projectObj._id, newProjectName).then((response) => {
          response = response.data;
          if (response.statusCode === 200) {
            const updatedProjectsData = [...projects];
            const projectIndex = updatedProjectsData.findIndex(
              (pObj) => pObj._id === projectObj._id
            );
            updatedProjectsData[projectIndex].name = newProjectName;
            setProjects(updatedProjectsData);

            message.success(response.message);
          } else {
            message.error(response.message);
          }
        });
      },
    });
  }

  function handleDeleteProject(projectObj) {
    Modal.confirm({
      title: "Delete project - " + projectObj.name,
      onOk() {
        trackEvent("projects_delete_button_clicked", {
          ide_project_stack_name: projectObj.projectLanguage,
        });

        deleteProject(projectObj._id).then((response) => {
          response = response.data;
          if (response.statusCode === 200) {
            const updatedProjectsData = [...projects];
            const projectIndex = updatedProjectsData.findIndex(
              (pObj) => pObj._id === projectObj._id
            );
            updatedProjectsData.splice(projectIndex, 1);
            setProjects(updatedProjectsData);
            message.success(response.message);
          } else {
            message.error(response.message);
          }
        });
      },
    });
  }

  function handleAddOrRemoveToPortfolio(projectObj) {
    let modalTitle;
    if (projectObj.showInPortFolio) {
      modalTitle =
        "Do you want to remove your project - " +
        projectObj.name +
        " from portfolio.";

      trackEvent("projects_remove_from_portfolio_button_clicked", {
        ide_project_stack_name: projectObj.projectLanguage,
      });
    } else {
      modalTitle =
        "Do you want to add your project - " +
        projectObj.name +
        " to portfolio.";

      trackEvent("projects_add_to_portfolio_button_clicked", {
        ide_project_stack_name: projectObj.projectLanguage,
      });
    }

    Modal.confirm({
      title: modalTitle,
      icon: projectObj.showInPortFolio ? <StarFilled /> : <StarOutlined />,
      onOk() {
        addOrRemoveIdeProjectPortfolio(
          projectObj._id,
          !projectObj.showInPortFolio
        ).then((response) => {
          response = response.data;
          if (response.statusCode === 200) {
            const updatedProjectsData = [...projects];
            const projectIndex = updatedProjectsData.findIndex(
              (pObj) => pObj._id === projectObj._id
            );
            updatedProjectsData[projectIndex].showInPortFolio =
              !projectObj.showInPortFolio;
            setProjects(updatedProjectsData);

            message.success(
              projectObj.showInPortFolio
                ? "Successfully added to portfolio"
                : "Successfully removed from portfolio"
            );
          } else {
            message.error(response.message);
          }
        });
      },
    });
  }

  function handleProjectSubmission(projectObj) {
    Modal.confirm({
      title:
        "Are you sure you want to submit your project " +
        projectObj.name +
        " for evaluation",
      content:
        "Once evaluated, you will not be able to make changes to the project.",
      icon: <ReadOutlined />,
      onOk: () => {
        submitIdeProjectForEvaluation(projectObj._id).then((response) => {
          response = response.data;
          if (response.statusCode === 200) {
            const updatedProjectsData = [...projects];
            const projectIndex = updatedProjectsData.findIndex(
              (pObj) => pObj._id === projectObj._id
            );
            updatedProjectsData[projectIndex].submittedForEvaluation = true;
            setProjects(updatedProjectsData);

            message.success(response.message);
          } else {
            message.error(response.message);
          }
        });
      },
    });
  }

  function handleCancelProjectSubmission(projectObj) {
    Modal.confirm({
      title:
        "Are you sure you want to cancel your submission for project " +
        projectObj.name,
      icon: <ReadFilled />,
      content:
        "Your project will no longer be available for evaluation for teacher / trainer",
      onOk: () => {
        cancelIdeProjectSubmission(projectObj._id).then((response) => {
          response = response.data;
          if (response.statusCode === 200) {
            const updatedProjectsData = [...projects];
            const projectIndex = updatedProjectsData.findIndex(
              (pObj) => pObj._id === projectObj._id
            );
            updatedProjectsData[projectIndex].submittedForEvaluation = false;
            setProjects(updatedProjectsData);

            message.success(response.message);
          } else {
            message.error(response.message);
          }
        });
      },
    });
  }

  function createProject(projectStackName) {
    trackEvent("projects_page_create_project_button_clicked", {
      ide_project_stack_name: projectStackName,
    });

    const projectMetaData = getIdeProjectTypeMetaData(projectStackName);
    if (projectMetaData.route) {
      if (projectMetaData.openInNewTab) {
        window.open(projectMetaData.route + "?token=" + userToken);
      } else {
        navigate(projectMetaData.route);
      }
    } else {
      message.info("Coming soon.");
    }
  }

  function navigateToIDE(projectObj) {
    const projectMetaData = getIdeProjectTypeMetaData(
      projectObj.projectLanguage
    );

    trackEvent("projects_page_ide_button_clicked", {
      ide_project_stack_name: projectObj.projectLanguage,
    });

    if (projectMetaData ? projectMetaData.route : false) {
      if (projectMetaData.openInNewTab) {
        window.open(
          projectMetaData.route +
            "?token=" +
            userToken +
            "&lmsProjectId=" +
            projectObj._id
        );
      } else if (projectObj.projectLanguage === "sql2") {
        navigate(projectMetaData.route + projectObj.queryId);
      } else {
        navigate(projectMetaData.route + projectObj._id);
      }
    } else {
      message.info("Coming soon.");
    }
  }

  const filtersChanged = useCallback(
    (filters) => {
      setProjectLoading(true);

      const reqObj = {
        projectLanguage: projectStack,
        userLoginId: global_var.user_login_id,
        limitCount: 12,
        restrictLabAssignment: true,
        ...filters,
      };

      reqObj.pageNo = reqObj.pageNo - 1;

      getIdeProjects(reqObj).then((response) => {
        setProjectLoading(false);
        response = response.data;

        if (response.statusCode === 200) {
          setProjects(response.projects);
          setTotalProjectsCount(response.totalProjectsCount);
        } else {
          message.error(response.message);
        }
      });
    },
    [projectStack]
  );

  return (
    <>
      <Row className="mt-2">
        <Col
          className="col d-flex align-items-center"
          justify="space-evenly"
          align="middle"
        >
          <Link to="/" className="mr-2">
          <span className="mt-2 back-button">
            <LeftOutlined  className=" h4" style={{ color: '#000000' }} />
          </span>
          </Link>
          <span className="m-1 mt-2 h4 poppins-medium">My Projects</span>
        </Col>
        <Col className="mt-2">
        {showCreateProjectButton && (
          <Button className="poppins-medium"
            type="primary"
            onClick={() =>createProject(projectStack)
            }
            style={{ marginLeft: '8px',
              backgroundColor:'#E96358',
              fontSize:'12px'
            }}
          >
            Create New Project
          </Button>
        )}
        </Col>
      </Row>

      <Divider className="mt-1" style={{backgroundColor:"#D7BEF7"}}/>

      <ProjectFilters
        filtersChanged={filtersChanged}
        hideProjectTypeFilter={projectStack ? true : false}
        hideProjectStatusFilter={
          global_var.role_id === global_var.STUDENT_ROLE_ID ? false : true
        }
        totalProjectsCount={totalProjectsCount}
        searchBoxPlaceHolder={"Search Project name"}
        hideClassFilter ={global_var.needClass && (global_var.role_id !== global_var.STUDENT_ROLE_ID) ? false : true} 
        hideDivisionFilter ={global_var.needDivision && (global_var.role_id !== global_var.STUDENT_ROLE_ID) ? false : true} 
        hideAcademicYearFilter = {true}
      />

      <div className="row mx-2 left-padding">
        <div className="col">
          {projectLoading ? (
            <List
              grid={{
                gutter: 10,
                xs: 1,
                sm: 2,
                md: 3,
                lg: 3,
                xl: 3,
                xxl: 3,
              }}
              dataSource={Array(8).fill(0)}
              renderItem={() => (
                <List.Item className="mr-2 mb-5">
                  <CardSkeleton />
                </List.Item>
              )}
            />
          ) : (
            <List
              locale={{
                emptyText: (
                  <Empty
                    image={noDataImage}
                    description={
                      <div>
                        <p className="poppins-regular" style={{fontSize:'18px'}}>No Projects yet!</p>
                      </div>
                    }
                  />
                ),
              }}
              grid={{
                gutter: 10,
                xs: 1,
                sm: 2,
                md: 3,
                lg: 3,
                xl: 3,
                xxl: 3,
              }}
              dataSource={projects}
              renderItem={(projectObj) => (
                <List.Item className="mr-2 mb-3">
                  <Badge.Ribbon
                    text={getEvaluationStatusName(projectObj.evaluationStatus)}
                    color={getEvaluationStatusColor(
                      projectObj.evaluationStatus
                    )}
                    className={`poppins-regular ${
                      !projectObj.submittedForEvaluation ? "d-none glassBg" : "small"
                    }`
                    } 
                    style={{fontSize:'11px'}}
                  >
                    <Card className="glass card-divider" actions={setActions(projectObj)}>
                      <Meta
                        avatar={
                          <div style={{ marginTop: '10px' }}>
                            <Badge
                              style={{ color: "#0057ff"}}
                              count={
                                projectObj.showInPortFolio ? <StarFilled style={{color:'#FFC200'}} /> : 0
                              }
                            >
                              <Avatar
                              size={{
                                xs: 24,
                                sm: 32,
                                md: 40,
                                lg: 34,
                                xl: 50,
                                xxl: 30,
                              }}
                                src={getIdeProjectLogo(
                                  projectObj.projectLanguage
                                )}
                              />
                            </Badge>
                          </div>
                        }
                        title={
                          <Typography.Text
                            ellipsis={{ tooltip: projectObj.name }}
                          >
                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', maxWidth: '100%' }}>
                            <span className="poppins-regular" style={{
                              display: 'inline-block',
                              maxWidth: 'calc(100%) - 30px',
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                            }}>
                              {projectObj.name}
                            </span>
                            <Tooltip title={'Edit Project Title'}>
                              <EditIcon 
                                style ={{marginLeft:'10px', cursor: 'pointer',flexShrink: 0 }} 
                                onClick={() => handleEditProject(projectObj)}
                              />
                            </Tooltip>
                          </div>
                          </Typography.Text>
                        }
                        description={
                          <div className="d-flex align-items-center">
                            <Typography.Text className="poppins-regular" style={{fontSize:'12px'}}
                              ellipsis={{
                                tooltip: formatDate(projectObj.createdDate),
                              }}
                            >
                              {formatDate(projectObj.createdDate)}
                            </Typography.Text>
                          </div>
                        }
                      />
                    </Card>
                  </Badge.Ribbon>
                </List.Item>
              )}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default Projects;
